export const individualSteps = [
  {
    title: "Share Your Idea",
    description: "Define your challenge and the problem you want to solve. Whether it's data collection, model creation, or solution evaluation, LunorQuest supports it all."
  },
  {
    title: "Set Up Your Quest",
    description: "Use LunorFund to crowdfund resources and connect with experts who can bring your idea to life."
  },
  {
    title: "Collaborate Globally",
    description: "Engage with top data enthusiasts and AI professionals to co-create innovative solutions."
  },
  {
    title: "Achieve Results",
    description: "Implement solutions tailored to your needs, while fostering co-ownership and collaboration."
  }
]; 